import { TournamentState } from '@ps/web-poker-tile-mappers';
import { StarsButton, Translation } from '@ps/web-shared-components';
import classnames from 'clsx';
import React from 'react';

import { TournamentStateTranslations } from '../../constants';
import type { FilterVariables } from '../../types/MTT';

import { TXTCLI_Games, TXTCLI_Late_Registration } from './TournamentStateFilter.messages.json';
import styles from './TournamentStateFilter.scss';

export const FILTER_BUTTONS: Partial<TournamentState>[] = [
  TournamentState.LATE_REGISTRATION,
  TournamentState.REGISTERING,
  TournamentState.ANNOUNCED,
  TournamentState.RUNNING,
  TournamentState.COMPLETED
];

const TRANSLATIONS: typeof TournamentStateTranslations = {
  ...TournamentStateTranslations,
  [TournamentState.LATE_REGISTRATION]: TXTCLI_Late_Registration
};

interface TournamentStateFilterProps {
  filters: FilterVariables;
  filteredCount: number;
  handleStateFilterClick(state: TournamentState[]): void;
}

const TournamentStateFilter: React.FC<TournamentStateFilterProps> = ({
  filters,
  filteredCount,
  handleStateFilterClick
}) => {
  const handleClick = (state: TournamentState) => {
    const stateFilterSet = new Set(filters.state || []);

    const isRegistering = state === TournamentState.REGISTERING;
    if (stateFilterSet.has(state)) {
      stateFilterSet.delete(state);
      if (isRegistering) stateFilterSet.delete(TournamentState.PHASE);
    } else {
      stateFilterSet.add(state);
      if (isRegistering) stateFilterSet.add(TournamentState.PHASE);
    }

    handleStateFilterClick([...stateFilterSet]);
  };

  return (
    <div className={styles.root}>
      <div className={styles.states}>
        {FILTER_BUTTONS.map((state) => (
          <StarsButton
            data-testid={`filter-button-${state}`}
            key={`${state}-button`}
            variant="filter"
            className={classnames(styles.button, {
              [styles.buttonActive]: filters.state?.includes(state)
            })}
            translation={TRANSLATIONS[state]}
            onClick={() => handleClick(state)}
          />
        ))}
      </div>
      <div className={styles.options}>
        <div className={styles.games}>
          <Translation {...TXTCLI_Games} />: <span className={styles.count}>{filteredCount}</span>
        </div>
      </div>
    </div>
  );
};

export default TournamentStateFilter;
